import React, {useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import { transferirEntreCajas} from '../../redux/reducers/cajasReducers';
import {Dialog, DialogActions, DialogContent, Button, Grid, Theme, TextField, CircularProgress} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import LoadingProgress from "../../components/LoadingProgress";
import {MostrarError} from "../../components/MostrarError";
import {TextFieldCurrency} from "../../components/CustomTextField";
import Strings from "../../assets/strings";
import SelectCaja from "../../components/selects/SelectCaja";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ICajaTransferencia} from "../../redux/types/ICaja";
const useStyles = makeStyles((theme:Theme) => ({
    root: {
        boxShadow: "none",
        [theme.breakpoints.up('sm')]: {
            maxWidth:510,
            margin:"0px auto",
        },
    },
    content:{
        padding:theme.spacing(2),
    }
}));

const initialState:ICajaTransferencia = {
    monto: 0,
    cajaIdDestino:undefined,
    cajaId: undefined,
    comentario: '',
};
export default function TransferenciaCajas() {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {state:urlState={}} = useLocation();
    const classes = useStyles();
    const { error, status} = useAppSelector(state => state.cajas)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [state, setState] = useState(initialState);

    useEffect(()=>{
        if(urlState && urlState.modalTransferenciaCaja) {
            setState(initialState);
            setOpen(true);
        }else{
            setState(initialState);
            setOpen(false);
        }
    },[urlState,setState])
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name,value} = e.target;
        setState({...state,  [name]: value });
    };
    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true)
        dispatch(transferirEntreCajas(state)).finally(()=>{
            setLoading(false)
        })
    }
    return (
        <Dialog className={classes.root} open={open} onClose={()=>navigate(-1)} fullWidth maxWidth={"sm"}>
            <TopBarDialog title={Strings.transferenciaCaja} onClose={()=>navigate(-1)} nofullScreen/>
            <DialogContent className={classes.content}>
                <MostrarError errors={error}/>
                {status === "loading" && <LoadingProgress />}
                <form onSubmit={submit} id="form1">
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <SelectCaja
                            name="cajaId"
                            label={Strings.desde}
                            value={state.cajaId}
                            required
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectCaja
                            name="cajaIdDestino"
                            label={Strings.hasta}
                            value={state.cajaIdDestino}
                            required
                            onChange={handleChange}
                            removeOption={state.cajaId}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextFieldCurrency
                            name="monto"
                            label={Strings.monto}
                            value={state.monto}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            multiline
                            name="comentario"
                            label={Strings.concepto}
                            value={state.comentario}
                            fullWidth
                            onChange={handleChange}
                            inputProps={{maxLength: 100}}
                        />
                    </Grid>
                  </Grid>
                </form>
            </DialogContent>
          <DialogActions>
              <Button type={"button"} color="warning" variant={"text"} onClick={()=>navigate(-1)}>
                  {Strings.cancelar}
              </Button>
              <Button type="submit" form={"form1"} color="primary"  disabled={loading} variant={"outlined"}
              >
                  {loading ? (
                      <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                  ):(
                      <span>{Strings.guardar}</span>
                  )}
              </Button>


          </DialogActions>

        </Dialog>
    );
}




